

// Safe Unicode Base64 encoding
export const base64EncodeUnicode = (str) => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode('0x' + p1)
    )
  );
};

// Safe Unicode Base64 decoding
export const base64DecodeUnicode = (str) => {
  try {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch (error) {
    console.error('Failed to decode Base64 Unicode:', error);
    return '';
  }
};


// utils/dateFormatter.js
export const formatDate = (value) => {
  const date = new Date(value);
  if (isNaN(date)) return ''; // handle invalid date
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
